/**
 * @fileName      cs
 * @dateTime      2021/3/25 16:45:31
 * @author        Millionfor <millionfor@gmail.com>
 * @description
 */

export default {
  path: '/app-cs',
  name: 'app-cs',
  meta: {
    title: '客服中心'
  },
  component: () => import('@/conf/home/pages/cs'),
  children: [
    {
      path: '/app-cs/manage',
      name: 'app-cs-manage',
      redirect: '/app-cs/manage/manage',
      meta: {
        title: '客服管理'
      },
      component: () => import('@/conf/home/pages/cs/manage'),
      children: [
        {
          path: '/app-cs/manage/manage',
          name: 'app-cs-manage-manage',
          meta: {
            title: '客服管理'
          },
          component: () => import('@/conf/home/pages/cs/manage/manage')
        },
        {
          path: '/app-cs/manage/group',
          name: 'app-cs-manage-group',
          meta: {
            title: '客服分组'
          },
          component: () => import('@/conf/home/pages/cs/manage/group')
        }
      ]
    },
    {
      path: '/app-cs/setting',
      name: 'app-cs-setting',
      redirect: '/app-cs/setting/basis',
      meta: {
        title: '客服设置'
      },
      component: () => import('@/conf/home/pages/cs/setting'),
      children: [
        {
          path: '/app-cs/setting/basis',
          name: 'app-cs-setting-basis',
          meta: {
            title: '基本设置'
          },
          component: () => import('@/conf/home/pages/cs/setting/basis')
        },
        {
          path: '/app-cs/setting/automatic',
          name: 'app-cs-setting-automatic',
          meta: {
            title: '自动/快捷回复'
          },
          component: () => import('@/conf/home/pages/cs/setting/automatic')
        },
        {
          path: '/app-cs/setting/comment',
          name: 'app-cs-setting-comment',
          meta: {
            title: '服务评价与反馈'
          },
          component: () => import('@/conf/home/pages/cs/setting/comment')
        }
      ]
    },
    {
      path: '/app-cs/tripartites',
      name: 'app-cs-tripartites',
      meta: {
        title: '三方在线咨询'
      },
      redirect: '/app-cs/tripartites/mt',
      component: () => import('@/conf/home/pages/cs/tripartites'),
      children: [
        {
          path: '/app-cs/tripartites/mt',
          name: 'app-cs-tripartites-mt',
          meta: {
            title: '美团客服'
          },
          component: () => import('@/conf/home/pages/cs/tripartites/mt')
        }
      ]
    },
    {
      path: '/app-cs/conver-records',
      name: 'app-cs-converrecords',
      meta: {
        title: '会话记录'
      },
      component: () => import('@/conf/home/pages/cs/converRecords')
    },
    {
      path: '/app-cs/records',
      name: 'app-cs-records',
      meta: {
        title: '用户记录'
      },
      component: () => import('@/conf/home/pages/cs/records')
    },
    {
      path: '/app-cs/conversation',
      name: 'app-cs-conversation',
      redirect: '/app-cs/conversation/cst',
      meta: {
        title: '会话统计'
      },
      component: () => import('@/conf/home/pages/cs/conversation'),
      children: [
        {
          path: '/app-cs/conversation/cst',
          name: 'app-cs-conversation-cst',
          meta: {
            title: '会话统计'
          },
          component: () => import('@/conf/home/pages/cs/conversation/cst')
        },
        {
          path: '/app-cs/conversation/works',
          name: 'app-cs-conversation-works',
          meta: {
            title: '客服工作量'
          },
          component: () => import('@/conf/home/pages/cs/conversation/works')
        },
        {
          path: '/app-cs/conversation/quality',
          name: 'app-cs-conversation-quality',
          meta: {
            title: '客服工作质量'
          },
          component: () => import('@/conf/home/pages/cs/conversation/quality')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/js/conf/home/router/cs.js